export const PERSON_CAR_OWNER = 1;
export const COMPANY_CAR_OWNER = 0;
